import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import validator from 'validator';

import SocialBlock from '~/components/organisms/editor/SocialBlock/SocialBlock';
import TextInput from '~/components/ui/TextInput';
import VCardPlusImages from '~/components/VCardPlusQRContent/VCardPlusContent/VCardPlusImages';
import { type VCardPlusData } from '~/types/qrCode';
import { isMaxLength } from '~/utils/common';

import VCardPlusCompanies from './VCardPlusCompanies';

type VCardPlusContentProps = {
  gridSelectorMaxWidth?: number;
  createVCardPlusSocial?: () => void;
  updateVCardPlusSocialData?: () => void;
  updateVCardPlusData?: () => void;
  vCardPlusData?: VCardPlusData;
  deleteVCardPlusSocial?: () => void;
  createVCardPlusCompany?: () => void;
  deleteVCardPlusCompany?: () => void;
  updateVCardPlusCompany?: () => void;
  createVCardPlusImage?: () => void;
  deleteVCardPlusImage?: () => void;
};

export default function VCardPlusContent({
  gridSelectorMaxWidth,
  createVCardPlusSocial,
  updateVCardPlusSocialData,
  vCardPlusData,
  deleteVCardPlusSocial,
  createVCardPlusCompany,
  deleteVCardPlusCompany,
  updateVCardPlusCompany,
  updateVCardPlusData,
  createVCardPlusImage,
  deleteVCardPlusImage,
}: VCardPlusContentProps) {
  const { t } = useTranslation();
  const [socialsTitle, setSocialsTitle] = useState(vCardPlusData?.socialsTitle);

  const sendContentFooterField = () => {
    updateVCardPlusData({
      socials_title: socialsTitle,
    });
  };

  const handleSocialLinks = (val, type, index) => {
    if (vCardPlusData) {
      const addingValue = {
        network: val[index]?.network.toUpperCase() || '',
        url: val[index]?.value,
        title: val[index]?.title,
        microsite: vCardPlusData.id,
      };

      const areValValid = val.every((item) => validator.isURL(item.value));

      if (areValValid) {
        if (type === 'add') {
          createVCardPlusSocial(addingValue);
        } else if (type === 'update') {
          updateVCardPlusSocialData({ socialId: vCardPlusData?.socials[index]?.id, body: addingValue });
        } else if (type === 'delete') {
          deleteVCardPlusSocial(vCardPlusData?.socials[index]?.id);
        }
      }
    }
  };

  return (
    <>
      <VCardPlusImages
        gridSelectorMaxWidth={gridSelectorMaxWidth}
        updateVCardPlusData={updateVCardPlusData}
        vCardPlusData={vCardPlusData}
        createVCardPlusImage={createVCardPlusImage}
        deleteVCardPlusImage={deleteVCardPlusImage}
      />
      <VCardPlusCompanies
        createVCardPlusCompany={createVCardPlusCompany}
        vCardPlusData={vCardPlusData}
        deleteVCardPlusCompany={deleteVCardPlusCompany}
        updateVCardPlusCompany={updateVCardPlusCompany}
      />
      <SocialBlock
        setSocialLinks={handleSocialLinks}
        socialLinks={vCardPlusData?.socials?.map((item) => {
          return {
            network: item.network,
            value: item.url,
          };
        })}
        renderLabel={false}
        renderTextField={() => (
          <TextInput
            value={socialsTitle}
            helperText={isMaxLength(socialsTitle, 100)}
            inputProps={{ maxLength: 100 }}
            onChange={(e) => setSocialsTitle(e.target.value)}
            onBlur={() => sendContentFooterField()}
            sx={{ mb: 2 }}
            fullWidth
            label={t('other:title')}
            placeholder={t('template2:writeHere')}
          />
        )}
      />
    </>
  );
}
